"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./Typeahead.scss");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _downshift = require("downshift");

var _downshift2 = _interopRequireDefault(_downshift);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utils = require("../../../utils");

var _Icons = require("../../Icons");

var _ControllerButton = require("../ControllerButton");

var _ControllerButton2 = _interopRequireDefault(_ControllerButton);

var _InputErrorMessage = require("../InputErrorMessage");

var _InputErrorMessage2 = _interopRequireDefault(_InputErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getInputValue = function getInputValue(value, data) {
  var previousValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var option = data.find(function (e) {
    return e.value === value;
  });
  return option ? option.text : previousValue;
};

var className = 'c-Typeahead';

var Typeahead =
/*#__PURE__*/
function (_Component) {
  _inherits(Typeahead, _Component);

  function Typeahead(props) {
    var _this;

    _classCallCheck(this, Typeahead);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Typeahead).call(this, props));

    _this.getDisabledClass = function () {
      return _this.props.disabled ? "".concat(className, "__input--disabled") : '';
    };

    _this.inputActiveClass = function (isOpen) {
      return ["c-Typeahead__input".concat(isOpen ? ' c-Typeahead__input--active' : ''), _this.getDisabledClass(), _this.state.focus ? "c-Typeahead__input--focused" : '', _this.props.error ? "c-Typeahead__input--error" : ''].join(' ');
    };

    _this.filterItems = function (inputValue) {
      var data = _this.props.data;
      if (!inputValue) return data;
      return data.sort(function (a, b) {
        return a.text.localeCompare(b.text);
      }).filter(function (item) {
        return item.text.toLowerCase().startsWith(inputValue.toLowerCase().trim());
      });
    };

    _this.handleOnFocus = function () {
      _this.setState({
        focus: true
      });
    };

    _this.handleOnBlur = function (e) {
      _this.setState({
        focus: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
    };

    _this.onChange = function (selectedValue) {
      _this.props.onChange(selectedValue);
    };

    _this.itemToString = function (i) {
      return i ? i.text : '';
    };

    var value = _this.props.value ? getInputValue(_this.props.value, _this.props.data) : '';
    _this.state = {
      inputValue: value,
      focus: false
    };
    return _this;
  }

  _createClass(Typeahead, [{
    key: "valueAndDataChanged",
    value: function valueAndDataChanged(prevProps) {
      return prevProps.value !== this.props.value && prevProps.data !== this.props.data;
    }
  }, {
    key: "valueOrDataChanged",
    value: function valueOrDataChanged(prevProps) {
      return prevProps.value !== this.props.value || prevProps.data !== this.props.data;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.valueAndDataChanged(prevProps)) this.setState({
        inputValue: ''
      });else if (this.valueOrDataChanged(prevProps)) this.setState({
        inputValue: this.props.data ? getInputValue(this.props.value, this.props.data, this.state.inputValue) : this.state.inputValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var initialValue = this.props.data.find(function (option) {
        return option.value === _this2.props.value;
      });
      var _this$props = this.props,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          name = _this$props.name;
      var stateInputValue = this.state.inputValue;
      return _react2.default.createElement("div", {
        className: className
      }, _react2.default.createElement(_InputErrorMessage2.default, {
        id: "".concat(name, "ErrorMessage"),
        error: error,
        errorMessage: errorMessage
      }), _react2.default.createElement(_downshift2.default, {
        itemToString: this.itemToString,
        onChange: this.onChange,
        initialSelectedItem: initialValue
      }, function (_ref) {
        var getInputProps = _ref.getInputProps,
            getToggleButtonProps = _ref.getToggleButtonProps,
            getItemProps = _ref.getItemProps,
            isOpen = _ref.isOpen,
            clearSelection = _ref.clearSelection,
            selectedItem = _ref.selectedItem,
            highlightedIndex = _ref.highlightedIndex;
        return _react2.default.createElement("div", {
          className: "".concat(className, "__input-wrapper")
        }, _react2.default.createElement("div", {
          className: "".concat(className, "__relative-container")
        }, _react2.default.createElement("input", _extends({
          className: _this2.inputActiveClass(isOpen)
        }, getInputProps({
          placeholder: _this2.props.placeholder,
          name: _this2.props.name,
          id: _this2.props.name,
          value: stateInputValue,
          disabled: _this2.props.disabled,
          onChange: function onChange(e) {
            _this2.setState({
              inputValue: e.currentTarget.value
            });

            _this2.onChange(null);

            clearSelection();
          },
          onFocus: _this2.handleOnFocus
        }), {
          onBlur: _this2.handleOnBlur
        })), selectedItem ? _react2.default.createElement(_ControllerButton2.default, {
          onClick: function onClick() {
            _this2.setState({
              inputValue: ''
            });

            clearSelection();
          },
          type: 'button',
          "aria-label": "clear selection"
        }, _react2.default.createElement(_Icons.XIcon, null)) : _react2.default.createElement(_ControllerButton2.default, getToggleButtonProps(), _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _freeSolidSvgIcons.faSearch,
          color: "#a1a0a3"
        }))), _react2.default.createElement("div", {
          className: "".concat(className, "__relative-container")
        }, _react2.default.createElement("div", {
          className: "".concat(className, "__menu").concat(isOpen ? " ".concat(className, "__menu--open") : '')
        }, isOpen ? _this2.filterItems(stateInputValue).map(function (item, index) {
          return _react2.default.createElement("div", _extends({
            className: "".concat(className, "__item").concat(highlightedIndex === index ? " ".concat(className, "__item--active") : '').concat(selectedItem === item ? " ".concat(className, "__item--selected") : ''),
            key: item.key
          }, getItemProps({
            item: item,
            index: index
          })), _react2.default.createElement("span", {
            id: "".concat(name, "_").concat(item.text)
          }, _this2.itemToString(item)));
        }) : null)));
      }));
    }
  }]);

  return Typeahead;
}(_react.Component);

exports.default = Typeahead;